
import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private _router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (localStorage.getItem('AuthToken')) {
            return true;
        }

        this._router.navigate(['/account/login'], { queryParams: { returnUrl: state.url } });
    }
}



// WEBPACK FOOTER //
// ./src/helpers/auth.guard.ts